export default __webpack_public_path__ + "static/media/icon-guias.3fea92be.svg";